import { useMemo, lazy } from "react";

/**
 * Builds a stable map of path -> React.lazy(component) from a route config array.
 * Used by AuthenticatedRoutes and UnauthenticatedRoutes for consistent lazy loading.
 *
 * @param {Array<{ path: string, component?: () => Promise<{ default: React.ComponentType }> }>} routesArray
 * @returns {Record<string, React.LazyExoticComponent<React.ComponentType>>}
 */
function useLazyRouteMap(routesArray) {
  return useMemo(() => {
    const map = {};
    routesArray.forEach((r) => {
      if (r.component) map[r.path] = lazy(r.component);
    });
    return map;
  }, [routesArray]);
}

export { useLazyRouteMap };
